<template>
  <div v-if="currencyList?.length" class="currency-switcher">
    <DefSelectWrapper name="currency">
      <template #header>
        <svg class="currency-switcher-icon">
          <use xlink:href="#svg-wallet"></use>
        </svg>
        {{ selectedCurrency?.UF_PRINT_NAME }}
      </template>
      <p
        v-for="item in currencyList"
        :key="item.ID"
        class="currency-switcher-item"
        @click="changeCurrency(item)"
      >
        {{ item?.UF_PRINT_NAME }}
      </p>
    </DefSelectWrapper>
  </div>
</template>

<script lang="ts" setup>
import DefSelectWrapper from '@components/Def/DefSelect/DefSelectWrapper.vue';
import useCurrencies from '@use/useCurrencies/useCurrencies';

const currencies = useCurrencies();

const { selectedCurrency, currencyList, changeCurrency } = currencies;
</script>

<style lang="scss" scoped>
.currency-switcher {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  min-width: 45px;
  margin-right: 24px;
  &:hover {
    color: var(--color-link-hover);
  }
  :deep(.def-select-wrapper__front) {
    justify-content: center;
    background-color: transparent;
    min-height: 40px;
    border: unset;
    transition: 0.2s linear color;
    padding: 0 22px 0 0;
    &:hover {
      color: var(--color-link-hover);
    }
  }
  :deep(.def-select-wrapper__close) {
    right: 0;
    fill: currentColor;
  }
  :deep(.def-select-wrapper__drop) {
    top: 100%;
  }
  :deep(.def-select-wrapper__header) {
    display: flex;
    align-items: center;
    gap: 4px;
  }
}
.currency-switcher-item {
  width: 100%;
  padding: 8px;
  color: var(--color-main);
  transition: 0.2s linear background-color;
  &:hover {
    background-color: var(--color-link-hover);
  }
}
.currency-switcher-icon {
  width: 18px;
  height: 18px;
  fill: currentColor;
}
</style>
